import Api from 'src/services/ApiService';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import { CommonAxiosResponse } from 'src/types';
import {
  ChequeDetailsResponse,
  ChequeListPayload,
  ChequeListResponse,
  CreateChequeApiPayload,
  CreateChequeResponse,
  UpdateChequeApiPayload,
  UpdateChequeResponse
} from './types';

export const createChequeThunk = createAsyncThunk<
  CommonAxiosResponse<CreateChequeResponse>,
  CreateChequeApiPayload,
  { state: RootState }
>('po/cheque/createChequeThunk', async (data) => {
  const response = await Api.post('/po/cheque/create', data);
  return response;
});

export const updateChequeThunk = createAsyncThunk<
  CommonAxiosResponse<UpdateChequeResponse>,
  UpdateChequeApiPayload,
  { state: RootState }
>('po/cheque/updateChequeThunk', async (data) => {
  const response = await Api.patch(`po/cheque/update/${data?.cheque_id}`, data);
  return response;
});

export const chequeListThunk = createAsyncThunk<
  CommonAxiosResponse<ChequeListResponse>,
  ChequeListPayload,
  { state: RootState }
>('po/cheque/chequeListThunk', async (data) => {
  const response = await Api.get(`/po/cheque/get`, data);
  return response;
});

export const chequeDetailsThunk = createAsyncThunk<
  CommonAxiosResponse<ChequeDetailsResponse>,
  number,
  { state: RootState }
>('po/cheque/chequeDetailsThunk', async (cheque_id) => {
  const response = await Api.get(`/po/cheque/get/${cheque_id}`);
  return response;
});

//TODO: implement later
export const deleteChequeThunk = createAsyncThunk<
  CommonAxiosResponse<void>,
  number,
  { state: RootState }
>('po/cheque/deleteChequeThunk', async (cheque_id) => {
  const response = await Api.delete(`/po/cheque/delete/${cheque_id}`);
  return response;
});
